import styled from 'styled-components';
const ViewDetailsWrapper = styled.div`
.view-details{
	margin-left:20px;
	.ant-popover-inner{
		border-radius:10px;
		
	}
}
.close-sidebar{
	font-family: "open sans", sans-serif;
    font-size: 27px;
    top: 0px;
    color: #000;
    width: 40px;
    height: 40px;
    position: absolute;
    text-align: center;
    right: 11px;
    line-height: 40px;
	font-weight: 100;
	cursor: pointer;
  }
`;

export default (ViewDetailsWrapper);

